module.exports = __webpack_public_path__ + "img/Kamera_Express_faded_logo.5b851ac.webp";